/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JDxpertConfig } from '../models/JDxpertConfig';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class JdxpertService {

    /**
     * Return jdxpert config
     * @returns any Success
     * @throws ApiError
     */
    public static getJDxpertConfig(): CancelablePromise<{
        jdxpertConfig: (JDxpertConfig | Record<string, any> | null);
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jdxpert',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create jdxpert config
     * @returns any Success
     * @throws ApiError
     */
    public static createJDxpertConfig({
        requestBody,
    }: {
        requestBody: {
            prefix: string;
        },
    }): CancelablePromise<{
        jdxpertConfig: JDxpertConfig;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jdxpert',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete jdxpert config
     * @returns any Success
     * @throws ApiError
     */
    public static deleteJDxpertConfig(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/jdxpert',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
